import { render } from "./fb-vog-icon.svg?vue&type=template&id=6e7c8a19"
const script = {}
script.render = render

export default script